import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { TradeAdminRoutingModule } from '../../tradeAdmin-routing.module';
import { EnitComplainceRoutingModule } from '../../eComplaince-routing.module'
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SharedModule } from '../../../../shared/shared.module'
import { CtclModule } from '../../EnitTrade/ctcl/ctcl.module';

//     <=========== Complaince Modules Below ===========>

//import { PreviousQuarterMlaiListComponent } from './EnitCompliance/previous-quarter-mlai-list/previous-quarter-mlai-list.component';



// import {CyberSecurityAdminListComponent} from './EnitCompliance/cyber-security-admin-list/cyber-security-admin-list.component'

import { AgGridModule } from 'ag-grid-angular';

//P2P


//Cyber & System


//import { ShareHoldingCorporateComponentComponent } from './EnitCompliance/share-holding-corporate-component/share-holding-corporate-component.component';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { HighchartsChartModule } from 'highcharts-angular';
import { ChangeClearingMemberReportComponent } from './change-clearing-member-report/change-clearing-member-report.component';
import { ChangeClearingMemberFormViewComponent } from './change-clearing-member-form-view/change-clearing-member-form-view.component';
import { ChangeClearingMemberFormComponent } from './change-clearing-member-form/change-clearing-member-form.component';




@NgModule({
  declarations: [
    
    //     <=========== Complaince Modules Below ===========>
    
    // <----------------COLO MODULES ------------------>
    
    // <------------- HalfYeraly Networth Module ------------->
    //  <----------  Advertisement Module ------------->


    // <---------- Change in Address ----------->


    // <----------  Annual Return for Global Access ---------->
   
    //<--------- System Audit --------->


    //System Audit

    
    // Internal Audit
    
    //annual Return
    
    // ChangeInClearingMemberComponent,
    ChangeClearingMemberFormComponent,
    ChangeClearingMemberFormViewComponent,
    ChangeClearingMemberReportComponent,

    //Global Access for Annual Return 
    
    // <------------ P2P Connectivity ------------>
  
    //Cyber Audit
   
    //Authorised Person
    
    //Surrender Submission
    
    /////AuditTrailComponent
    

    //Pro-Enablement
    
    //NNF
   
    //LES
    
    //QuartelyRegReport
    

    //PN3
   



    //Change in director
    

    //Penalty Calculations
    

    //Change in shareHolding
    

    //BMC

    //Change in Member Details
    

    // Issuance of Report
    
    //multi Locking removal
   
    // MIS Dashboard
   

    //first trade certificate
    
    //Ip Surrender
    

    //Annual Compliance Audit 
    


  ],
  imports: [
    
    CommonModule,
    TradeAdminRoutingModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    SharedModule,
    CtclModule,
    EnitComplainceRoutingModule,
    AgGridModule,
    BaseChartDirective,
    HighchartsChartModule
  ]
})
export class ChangeInClearingMemberModule { }
